const LOCALES = {
  ENGLISH: 'en-us',
  SERBIAN: 'srb'
};

export default LOCALES;
